import { config, authApi, takeLatestRequest, Log, sagaEffects, ErrorsUtils } from '../../dependencies';

import { types, updateUserSuccess, updateUserFailure, updateUserInvalidate } from '../actions';

const { put } = sagaEffects;

function* updateUser(action, cancelToken) {
    const { id } = action.meta;

    try {
        const { data } = yield* authApi.put(config.api.user, action.payload, {
            uriParams: { id },
            cancelToken,
        });

        yield put(updateUserSuccess(id, data));
    } catch (e) {
        Log.error(e);

        const errorMessage = ErrorsUtils.createUIErrorMessage(e, {
            fallback: {
                id: 'error.password.api.update',
            },
        });

        yield put(updateUserFailure(id, errorMessage));
    }
}

export default function* updateUserWatcher() {
    const actionTypes = {
        REQUEST: types.UPDATE_USER_REQUEST,
        cancelTask: updateUserInvalidate,
    };

    yield takeLatestRequest(actionTypes, updateUser);
}
